import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Proportion",
  "use": "icon-Proportion-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Proportion\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 170.715429L460.8 512l-332.8 341.284571C51.2 759.515429 0 640 0 512c0-128 51.2-247.515429 128-341.284571zM546.084571 0C810.715429 17.115429 1024 238.884571 1024 512c0 281.6-230.4 512-512 512-128 0-247.515429-51.2-332.8-128l366.884571-375.515429V0z m-68.169142 0v426.715429L179.2 128C256 51.2 358.4 8.484571 477.915429 0z\" p-id=\"827\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Proportion.svg
// module id = 8YKT
// module chunks = 51